/* ZaunScout: Zaunrechner im Hero der Startseite
   Richtpreis = Matten (Länge / 2,5 m, aufgerundet) + Pfosten (Matten + 1), günstigste lieferbare Variante je Höhe.
   Der Button übergibt Länge und Höhe an den Zaunkonfigurator (?laenge=20&hoehe=1230mm).
*/
(function () {
  'use strict';

  var MATTENLAENGE = 2.5;

  function euro(cent, nachkomma) {
    return (cent / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: nachkomma ? 2 : 0,
      maximumFractionDigits: nachkomma ? 2 : 0
    });
  }

  function stufen(text) {
    return String(text || '').split(/\n/).map(function (zeile) {
      var teile = zeile.split('|');
      if (teile.length !== 2) return null;
      return {
        ab: parseFloat(teile[0].replace(/[.€\s]/g, '').replace(',', '.')) * 100,
        pct: parseFloat(teile[1].replace(/[%\s]/g, '').replace(',', '.'))
      };
    }).filter(function (stufe) { return stufe && stufe.ab > 0 && stufe.pct > 0; })
      .sort(function (a, b) { return a.ab - b.ab; });
  }

  function init(box) {
    var daten;
    try {
      daten = JSON.parse(box.querySelector('[data-zh-calc-data]').textContent);
    } catch (e) {
      return;
    }
    var laengeInput = box.querySelector('[data-zh-calc-laenge]');
    var hoeheSelect = box.querySelector('[data-zh-calc-hoehe]');
    var totalEl = box.querySelector('[data-zh-calc-total]');
    var detailEl = box.querySelector('[data-zh-calc-detail]');
    var stufeEl = box.querySelector('[data-zh-calc-stufe]');
    var link = box.querySelector('[data-zh-calc-link]');
    var altEl = box.querySelector('[data-zh-calc-alt]');
    var sparEl = box.querySelector('[data-zh-calc-spar]');
    var versandEl = box.querySelector('[data-zh-calc-versand]');
    var versandText = box.querySelector('[data-zh-calc-versand-text]');
    var versandBar = box.querySelector('[data-zh-calc-versand-bar]');
    var freiAb = Number(daten.freiAb) || 0;
    var rabatte = stufen(daten.stufen);

    function rechnen() {
      var laenge = parseFloat(String(laengeInput.value).replace(',', '.'));
      if (!(laenge >= MATTENLAENGE)) laenge = MATTENLAENGE;
      var hoehe = hoeheSelect.value;
      var mattePreis = daten.matte[hoehe];
      var pfostenPreis = daten.pfosten[hoehe];
      if (!mattePreis || !pfostenPreis) {
        totalEl.textContent = 'auf Anfrage';
        detailEl.textContent = '';
        if (stufeEl) stufeEl.hidden = true;
        return;
      }
      var matten = Math.ceil(laenge / MATTENLAENGE - 1e-9);
      var pfosten = matten + 1;
      var summe = matten * mattePreis + pfosten * pfostenPreis;
      var rabatt = rabatte.filter(function (stufe) { return summe >= stufe.ab; }).pop();
      var endpreis = rabatt ? Math.round(summe * (1 - rabatt.pct / 100)) : summe;

      var naechste = rabatte.filter(function (stufe) { return summe < stufe.ab; })[0];
      totalEl.textContent = euro(endpreis);

      // Mengenrabatt sichtbar: alter Preis durchgestrichen, neuer Preis rot, Ersparnis in Euro
      var reduziert = endpreis < summe;
      totalEl.classList.toggle('is-sale', reduziert);
      if (altEl) {
        altEl.textContent = reduziert ? euro(summe) : '';
        altEl.hidden = !reduziert;
      }
      if (sparEl) {
        sparEl.textContent = reduziert ? 'Sie sparen ' + euro(summe - endpreis) + ' (' + rabatt.pct + ' %)' : '';
        sparEl.hidden = !reduziert;
      }

      // Versand: ab der Grenze grün „Versandkostenfrei“, darunter der Hinweis auf die Grenze
      if (versandEl && freiAb > 0) {
        var frei = endpreis >= freiAb;
        var anteil = Math.min(1, endpreis / freiAb);
        versandEl.classList.toggle('is-frei', frei);
        // Kurz und greifbar: Restbetrag fett, ab 70 % „Fast geschafft“; erreicht: grün mit Haken
        versandText.innerHTML = frei
          ? 'Versandkostenfrei'
          : (anteil >= 0.7 ? 'Nur noch ' : 'Noch ') + '<strong>' + euro(freiAb - endpreis) + '</strong> bis versandkostenfrei';
        if (versandBar) versandBar.style.width = Math.max(6, Math.round(anteil * 100)) + '%';
        versandEl.hidden = false;
      }
      detailEl.textContent = matten + ' Matten, ' + pfosten + ' Pfosten, ' + euro(endpreis / laenge, true) + ' pro Meter';
      // Ersparnis steht schon rot am Preis, hier nur noch die nächste Stufe
      var stufeText = naechste ? 'Ab ' + euro(naechste.ab) + ' automatisch ' + naechste.pct + ' % Rabatt' : '';
      if (stufeEl) {
        stufeEl.textContent = stufeText;
        stufeEl.hidden = !stufeText;
      } else if (stufeText) {
        detailEl.textContent += '. ' + stufeText + '.';
      }
      var ziel = new URL(box.getAttribute('data-link'), window.location.origin);
      ziel.searchParams.set('laenge', String(laenge));
      ziel.searchParams.set('hoehe', hoehe);
      link.href = ziel.pathname + ziel.search;
    }

    laengeInput.addEventListener('input', rechnen);
    hoeheSelect.addEventListener('change', rechnen);
    rechnen();
  }

  function start() {
    document.querySelectorAll('[data-zh-calc]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
